import type { AccentPalette } from "@/lib/types";

/** Curated accent palettes: [accent, soft-accent]. */
export const ACCENT_PALETTES: AccentPalette[] = [
  ["#6C63B5", "#EDEBF7"],
  ["#55508F", "#ECEAF5"],
  ["#4B5AA7", "#EAEDF7"],
  ["#7D5BA6", "#F1EAF7"],
  ["#3E7D6E", "#E8F1EE"],
  ["#1a1816", "#F0EEEC"],
];

export const DEFAULT_PALETTE_INDEX = 1; // #55508F

/** localStorage key holding the selected palette index. */
export const ACCENT_STORAGE_KEY = "nursetools_accent";

/**
 * Blocking snippet that applies the stored accent to `<html>` before the
 * first paint. Without it the app painted the default palette, then swapped
 * colours in a mount effect — a visible flash on every load.
 */
export function accentPrePaintScript(): string {
  const palettes = JSON.stringify(ACCENT_PALETTES);
  return `(function(){try{var p=${palettes};var i=${DEFAULT_PALETTE_INDEX};var r=localStorage.getItem(${JSON.stringify(
    ACCENT_STORAGE_KEY,
  )});if(r!=null){var v=JSON.parse(r);if(typeof v==="number"&&p[v])i=v;}var s=document.documentElement.style;s.setProperty("--accent",p[i][0]);s.setProperty("--accent-soft",p[i][1]);}catch(e){}})();`;
}
